import type { ContentLanguageCode } from '@/shared/constants';

/** Données d'audiodescription d'une œuvre, telles que saisies dans la modale épisode. */
export interface AudioDescriptionInput {
  /** Nouveau fichier par langue (à envoyer dans Storage). */
  files: Record<ContentLanguageCode, File | null>;
  /** Langue dont l'audio déjà enregistré est conservé (false = supprimé dans la modale). */
  kept: Record<ContentLanguageCode, boolean>;
  /** Transcription HTML (éditeur) par langue. */
  transcription: Record<ContentLanguageCode, string>;
}

function htmlToText(html: string): string {
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .trim();
}

/** Nombre de mots du texte affiché (Figma : « (193 mots) » sous la transcription). */
export function countWords(html: string): number {
  const text = htmlToText(html || '');
  return text ? text.split(/\s+/).length : 0;
}

/**
 * Langues publiées qui ont un audio d'AD mais pas de transcription.
 * RGAA 4.1 : un média audio publié a une transcription (D-009).
 */
export function findLanguagesMissingAdTranscription({
  languages,
  hasAudio,
  transcription,
  status,
}: {
  languages: string[];
  hasAudio: Partial<Record<string, boolean>>;
  transcription: Partial<Record<string, string>>;
  status: Partial<Record<string, 'draft' | 'published'>>;
}): string[] {
  return languages.filter(
    (lang) => status[lang] === 'published' && hasAudio[lang] && countWords(transcription[lang] ?? '') === 0,
  );
}
